<!-- @format -->

<button
	hmf-button
	[variant]="isMobile() ? 'secondary' : 'tertiary'"
	[size]="isMobile() ? 'small' : 'medium'"
	icon="arrow-down"
	(click)="handleClick()"
	[disabled]="disabled()">
	Complete the Set
</button>
